<template>
  <el-dialog
      :title="form2.channelId ? $t('text.editChannel') : $t('text.addChannel')"
      :visible="show"
      @close="closeDialog"
      @open="init"
      :close-on-click-modal="false"
      width="800px"
  >
    <el-form :model="form2" :rules="rules" ref="form2">
      <el-form-item
          :label="$t('text.channelName')"
          :label-width="formLabelWidth"
          prop="channelName"
      >
        <el-input
            v-model="form2.channelName"
            autocomplete="off"
            :placeholder="$t('message.inputChannelName')"
        ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.channelType')"
          :label-width="formLabelWidth"
          prop="productId"
      >
        <el-select
            v-model="form2.productId"
            filterable
            :placeholder="$t('message.chooseOne')"
            :disabled="isDisabled"
        >
          <el-option
              :label="$t('text.collection')"
              :value="PAYMENT_TYPE_ID_COLLECTION"
          ></el-option>
          <el-option :label="$t('text.disbursement')" :value="PAYMENT_TYPE_ID_PAYMENT"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          :label="$t('text.upstream')"
          :label-width="formLabelWidth"
          prop="upstream"
      >
        <el-input
              v-model="form2.upstream"
            autocomplete="off"
            :placeholder="$t('message.inputUpstream')"
        ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.transactionStatus')"
          prop="channelStatus"
          :label-width="formLabelWidth"
          required
      >
        <el-col :span="24">
          <el-select v-model="form2.channelStatus" :placeholder="$t('text.transactionStatus')">
            <el-option key="" :label="$t('option.null')" value=""></el-option>
            <el-option key="00" :label="$t('channelStatus.00')" value="00"></el-option>
            <el-option key="01" :label="$t('channelStatus.01')" value="01"></el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item
          :label="$t('text.minAmount')"
          :label-width="formLabelWidth"
          prop="minAmount"
      >
        <el-input
            v-model="form2.minAmount"
            autocomplete="off"
            :placeholder="$t('message.inputMinTransactionAmount')"
        ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.maxAmount')"
          :label-width="formLabelWidth"
          prop="maxAmount"
      >
        <el-input
            v-model="form2.maxAmount"
            autocomplete="off"
            :placeholder="$t('message.inputMaxTransactionAmount')"
        ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.quota')"
          :label-width="formLabelWidth"
          prop="quota"
      >
        <el-input
            v-model="form2.quota"
            autocomplete="off"
            :placeholder="$t('message.inputQuotaAmount')"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('text.priority')" :label-width="formLabelWidth" prop="priority">
        <el-input v-model="form2.priority" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.transactionAmountThreshold.Day')"
          :label-width="formLabelWidth"
          prop="alarmThresholdDay"
      >
        <el-input
            v-model="form2.alarmThresholdDay"
            autocomplete="off"
            :placeholder="$t('message.transactionAmountThreshold.Day')"
        ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.transactionAmountThreshold.Month')"
          :label-width="formLabelWidth"
          prop="alarmThresholdMonth"
      >
        <el-input
            v-model="form2.alarmThresholdMonth"
            autocomplete="off"
            :placeholder="$t('message.transactionAmountThreshold.Month')"
        ></el-input>
      </el-form-item>
      <el-form-item
          :label="$t('text.alarmBalanceThreshold')"
          :label-width="formLabelWidth"
          prop="alarmBalanceThreshold"
      >
        <el-input
            v-model="form2.alarmBalanceThreshold"
            autocomplete="off"
            :placeholder="$t('text.alarmBalanceThreshold')"
        ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.channelAgentName')"
          prop="agent"
          :label-width="formLabelWidth"
      >
        <el-col :span="24">
          <el-select
              v-model="form2.channelAgentName"
              :placeholder="$t('text.channelAgentName')"
              filterable
              allow-create
              clearable
              @change="handleAgentChange">
            <el-option
                v-for="agent in agentList"
                :key="agent.agentId"
                :label="agent.agentName"
                :value="agent.agentName"
            ></el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item :label="$t('text.ChannelFeeRate')" :label-width="formLabelWidth" prop="iftFeeRate">
        <el-input v-model="form2.iftFeeRate" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
          v-if="form2.channelAgentName"
          :label="$t('text.channelAgentRate')"
          :label-width="formLabelWidth"
          prop="channelAgentRate">
        <el-input v-model="form2.channelAgentRate" autocomplete="off"></el-input>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="saveSystem" v-if="isButton" :loading="isLoading"
      >{{ $t('text.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  PAYMENT_TYPE_ID_COLLECTION,
  PAYMENT_TYPE_ID_PAYMENT
} from "@/utils/Constant";

export default {
  name: "channelEdit",
  props: {
    show: Boolean,
    value: Object,
    action: String,
    channelOption: Array,
    agentList: []
  },
  data() {
    return {
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT,
      dialogShow: this.show,
      groups: "",
      isButton: true,
      isLoading: false,
      isDisabled: false,
      time: {start: "00:00", step: "00:05", end: "23:59"},
      form2: {
        channelName: "",
        channelStatus: "00",
        upstream: "",
        channelId: "",
        iftRate: "",
        ibftRate: "",
        fee: "",
        minAmount: "1",
        maxAmount: "50000",
        quota: "",
        tranStartTime: "00:00",
        tranEndTime: "00:00",
        productId: "",
        priority: "1",
        alarmThresholdDay: "0",
        alarmThresholdMonth: "0",
        alarmBalanceThreshold: "0",
        channelAgentName: "",
        channelAgentId: "",
        channelAgentRate: "",
        forceUpdate: false,
      },
      formLabelWidth: "140px",
      rules: {
        channelName: [
          {
            required: true,
            message: this.$t('message.inputChannelName'),
            trigger: ["blur", "change"]
          },
          {
            min: 1,
            max: 20,
            message: this.$t('message.channelNameLengthError'),
            trigger: ["blur", "change"]
          }
        ],
        channelStatus: [
          {
            required: true,
            message: this.$t('message.channelStatusRequiredError'),
            trigger: ["blur", "change"]
          }
        ],
        upstream: [
          {
            required: true,
            message: this.$t('message.upstreamRequiredError'),
            trigger: ["blur", "change"]
          },
          {
            min: 1,
            max: 200,
            message: this.$t('message.lengthLimitError', {max: '200'}),
            trigger: ["blur", "change"]
          }
        ],
        productId: [
          {
            required: true,
            message: this.$t('message.productIdRequiredError'),
            trigger: ["blur", "change"]
          }
        ],
        minAmount: [
          {
            pattern: /^\d{0,16}(\.\d{1,4})?$/,
            message: this.$t("message.amountError"),
            trigger: ["change", "blur"]
          }
        ],
        maxAmount: [
          {
            pattern: /^\d{0,16}(\.\d{1,4})?$/,
            message: this.$t("message.amountError"),
            trigger: ["change", "blur"]
          }
        ],
        quota: [
          {
            pattern: /^\d{0,16}(\.\d{1,4})?$/,
            message: this.$t("message.amountError"),
            trigger: ["change", "blur"]
          }
        ],
        rate: [
          {
            pattern: /^\d{0,3}(\.\d{1,3})?$/,
            message: this.$t('message.numberRangeError', {min: '0', max: '999.999'}),
            trigger: ["blur", "change"]
          }
        ],
        priority: [
          {
            pattern: /^[1-9][0-9]?$|^100$/,
            message: this.$t('message.numberRangeError', {min: '1', max: '100'}),
            trigger: ["blur", "change"]
          },
        ],
        channelAgentRate: [
          {
            required: true,
            pattern: /^\d{0,3}(\.\d{1,3})?$/,
            message: this.$t('message.numberRangeError', {min: '0', max: '999.999'}),
            trigger: ["blur", "change"]
          }
        ],
      }
    };
  },
  methods: {
    init() {
      if (this.action === "edit") {
        this.form2 = Object.assign({}, this.value);
        this.form2.minAmount = this.$formatter.FenToYuan(
            null,
            null,
            this.value.minAmount,
            null
        );
        this.form2.maxAmount = this.$formatter.FenToYuan(
            null,
            null,
            this.value.maxAmount,
            null
        );
        this.form2.quota = this.$formatter.FenToYuan(
            null,
            null,
            this.value.quota,
            null
        );
        this.form2.alarmThresholdDay = this.$formatter.FenToYuan(
            null,
            null,
            this.value.alarmThresholdDay,
            null
        );
        this.form2.alarmThresholdMonth = this.$formatter.FenToYuan(
            null,
            null,
            this.value.alarmThresholdMonth,
            null
        );
        this.form2.forceUpdate = false;
      }
    },
    closeDialog() {
      this.form2 = {
        channelName: "",
        channelStatus: "00",
        upstream: "",
        channelId: "",
        ibftRate: "",
        iftRate: "",
        fee: "",
        minAmount: "1",
        maxAmount: "50000",
        quota: "",
        tranStartTime: "00:00",
        tranEndTime: "00:00",
        productId: "",
        priority: "1",
        forceUpdate: false,
      };
      this.$refs["form2"].resetFields();
      this.$emit("update:show", false);
    },
    finishSuccess(msg, createdData) {
      this.$notify({
        title: this.$t('text.prompt'),
        message: msg || this.$t('text.success'),
        type: "success"
      });
      this.$bus.$emit("refresh");
      if (this.action === "add") {
        this.$emit('created', createdData || {
          channelName: this.form2.channelName,
          productId: this.form2.productId,
          channelStatus: this.form2.channelStatus
        });
      }
      this.closeDialog();
      this.$emit('refresh-agent-list');
    },
    saveSystem() {
      this.isLoading = true;
      this.$refs["form2"].validate((valid) => {
        if (!valid) {
          this.isLoading = false;
          return false;
        }
        let url = "/routeChannelInfo/routeChannelInfoAdd";
        if (this.action === "edit") {
          url = "/routeChannelInfo/routeChannelInfoUpdate";
        }
        this.form2.ibftFeeRate = this.form2.iftFeeRate;
        this.form2.forceUpdate = false;

        this.axios.post(url, this.form2).then((res) => {
          if (res.code === 200) {
            return this.finishSuccess(res.msg, res.data);
          }
          const warningMessage = (res.msg || '').replace(/；/g, '<br/>');
          return this.$confirm(
              `<div style="line-height: 1.6; margin-bottom: 12px;">${warningMessage}</div><div>${this.$t('message.confirmForceOperate')}</div>`,
              this.$t('text.prompt'),
              {
                confirmButtonText: this.$t('text.confirm'),
                cancelButtonText: this.$t('text.cancel'),
                type: 'warning',
                dangerouslyUseHTMLString: true,
              })
              .then(() => {
                this.form2.forceUpdate = true;
                return this.axios.post(url, this.form2).then((res2) => {
                  if (res2.code === 200) {
                    return this.finishSuccess(res2.msg, res2.data);
                  }
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res2.msg
                  });
                });
              })
              .catch(() => null);
        }).catch((e) => {
          this.$notify.error({
            title: this.$t('text.prompt'),
            message: e
          });
        }).finally(() => {
          this.isLoading = false;
        });
      });
    },
    handleAgentChange(selectedAgentName) {
      const selectedAgent = this.agentList.find(agent => agent.agentName === selectedAgentName);
      if (selectedAgent) {
        this.form2.channelAgentId = selectedAgent.agentId;
      } else {
        this.form2.channelAgentId = null;
      }
    }
  },
  mounted() {
    this.$bus.$on("refreshButton", (isButton) => {
      this.isButton = isButton;
    });
    this.$bus.$on("isDisabled", (isDisabled) => {
      this.isDisabled = isDisabled;
    });
    this.$bus.$on("dialogShow", (dialogShow) => {
      this.dialogShow = dialogShow;
    });
  }
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
